import React, { useState } from "react";
import Header from "../Header";
import Sidebar from "../Sidebar";
import { Outlet } from "react-router-dom";
import "./layout.css";
import useHasProductAccess from "../../hooks/useHasProductAccess";

function getInitialSidebarState() {
  const stored = localStorage.getItem("sidebar_expanded");
  return stored === null ? true : stored === "true";
}

function Layout() {
  const { hasAccess, isCheckingAccess } = useHasProductAccess();
  const [isSideBarShow, setIsSidebarShow] = useState(false);
  const [isExpanded, setIsExpanded] = useState(getInitialSidebarState());

  const expandRetractSidebar = () => {
    setIsExpanded((prev) => {
      localStorage.setItem("sidebar_expanded", !prev);
      return !prev;
    });
  };

  return (
    <div className="layout">
      <Header 
        hasAccess={hasAccess}
        onMenuClick={() => setIsSidebarShow(!isSideBarShow)} 
        onProfileClick={() => setIsSidebarShow(false)}
      />
      <div>
        {isCheckingAccess ? (
          <div className="flex items-center justify-center min-h-[calc(100vh-4rem)] mt-16 bg-gray-50">
            <p>Loading...</p>
          </div>
        ) : hasAccess ? (
          <>
            <Sidebar
              show={isSideBarShow}
              onClose={() => setIsSidebarShow(false)}
              isExpanded={isExpanded}
              expandRetractSidebar={expandRetractSidebar}
            />
            <div
              className={
                "content-wrapper min-h-[calc(100vh-4rem)] bg-gray-50 mt-16 " +
                (isExpanded ? "lg:ml-64" : "lg:ml-20")
              }
            >
              <Outlet />
            </div>
          </>
        ) : (
          <div className="content-wrapper min-h-[calc(100vh-4rem)] bg-gray-50 mt-16 p-4 flex items-center justify-center w-full lg:ml-0">
            <div className="bg-white rounded-2xl shadow-xl border border-gray-100 p-8 max-w-lg w-full flex flex-col items-center">
              <div className="w-16 h-16 bg-red-50 rounded-full flex items-center justify-center mb-4">
                <svg
                  className="w-8 h-8 text-red-500"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                  />
                </svg>
              </div>
              <h2 className="text-xl font-bold text-gray-900 mb-2 text-center">
                Company Access Denied
              </h2>
              <p className="text-sm text-gray-500 text-center mb-0">
                The current company does not have access to this product. Please use the top header to select another company to continue, or contact your administrator if you believe this is an error.
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Layout;
